module.exports = "/images/ACCESSOIRE..png?7533e51fcbe129349c40a5231117e1c3";